<h1 mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.description | translate"></p>
</div>
<div mat-dialog-actions class="actions">
  <button mat-flat-button color="primary" (click)="onOkClick()" cdkFocusInitial>Ok</button>
</div>
